
import { Options, Vue } from "vue-class-component";
import HeaderComponent from "./TheHeader/index.vue";
import FooterComponent from "./TheFooter/index.vue";

@Options({
  name: "pageLayout",
  components: {
    HeaderComponent,
    FooterComponent
  },
})
export default class PageLayout extends Vue {
  $refs!: {
    pageLayout: HTMLFormElement;
  };
  private resizeHandler(): void {
    this.setViewPortUnit();
  }

  private setViewPortUnit(): void {
    const vh = window.innerHeight * 0.01;
    this.$refs.pageLayout.style.setProperty("--vh", `${vh}px`);
  }

  beforeMount() {
    window.addEventListener("resize", this.resizeHandler);
  }

  mounted() {
    this.setViewPortUnit();
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.resizeHandler);
  }
}
